import { render, staticRenderFns } from "./BetslipAreaD.vue?vue&type=template&id=b884f324&scoped=true"
import script from "./BetslipAreaD.vue?vue&type=script&lang=js"
export * from "./BetslipAreaD.vue?vue&type=script&lang=js"
import style0 from "./BetslipAreaD.vue?vue&type=style&index=0&id=b884f324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b884f324",
  null
  
)

export default component.exports